import React, { useEffect, useState } from 'react'
import SocketService from '../Service/SocketService';
import { useDispatch, useSelector } from 'react-redux';
import { generateLabel } from '../utils';
import useDidMountEffect from './hooks/useDidMountEffect';
import { fetchActivityFeed } from '../redux/action/liveAuctionAction';

const ActivityFeed = ({ feedRef, lot_id }) => {
    const dispatch = useDispatch()
    const [activities, setActivities] = useState([]);
    const { isConnected } = useSelector((state) => state.socket);
    const selectedLot = useSelector((state) => state.liveAuction.selectedLot);
    const [isApiAttempted, setIsApiAttempted] = useState(false);
    const id = selectedLot?.id || lot_id;

    useDidMountEffect(() => {
        const container = feedRef?.current;
        if (!container) return;

        const isNearTop = container.scrollTop < 50;

        if (isNearTop) {
            container.scrollTop = 0;
        }
    }, [activities.length]);

    useEffect(() => {
        if (!id) return;

        const fetchActivities = async () => {
            try {
                const response = await dispatch(fetchActivityFeed({ lot_id: id }));

                const { code, data = [], error } = response || {};

                if (code !== 1 || error !== 0 || !data.length) {
                    setActivities([]);
                    return;
                }

                const activities = data.map(({ message, added_on }) => ({
                    text: message,
                    time: new Date(added_on),
                }));

                setActivities(activities);
            } catch (err) {
                console.error("API failed, fallback to socket only", err);
            } finally {
                setIsApiAttempted(true);
            }
        };
        fetchActivities();
    }, [id]);

    useEffect(() => {
        if (!isConnected || !isApiAttempted) return;

        const handleBroadcast = (data) => {
            setActivities((prev) => [
                { text: data.message, time: new Date() },
                ...prev,
            ]);
        };

        SocketService.on("bidderBroadcast", handleBroadcast);
        return () => {
            SocketService.off("bidderBroadcast", handleBroadcast);
        };
    }, [isConnected, isApiAttempted]);

    return (
      <div className={`feed-list  ${activities?.length>4?"scrollable":""}`} ref={feedRef} >
            {
                !activities.length ? (
                    <img className='nocomment' src="/img/no-comment.svg" alt="No Comment" />
                ) : (
                    activities?.map((item, i) => (
                        <div className='feed-box' key={i} style={styles.feedItem}>
                            <h6>
                                <div className="icon">
                                    <img src="/img/mike-icon.svg" alt="" />
                                </div>
                                {item.text}
                            </h6>
                            <span className='now' style={styles.time}> {
                                generateLabel(item.time, true)
                            }</span>
                        </div>
                    )))
            }
        </div>
    )
}

export default ActivityFeed;

const styles = {

}

